import { render, staticRenderFns } from "./MapUI.vue?vue&type=template&id=08f94b98"
import script from "./MapUI.vue?vue&type=script&lang=js"
export * from "./MapUI.vue?vue&type=script&lang=js"
import style0 from "./MapUI.vue?vue&type=style&index=0&id=08f94b98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports